import { IApplicationState } from '../../types/redux';

export function selectGeo(state: IApplicationState) {
  return state.geo;
}
